<template>
  <div class="d-flex justify-content-center align-items-center w-100">
    <img class="game-logo-icon-lrg m-3" :src="require(`../../brand/${brandConfig.brand}/assets/game-logo.webp`)">
  </div>
  <div class="d-flex flex-column align-items-center justify-content-center text-center pt-1 col-12 height">
    <h5 class="header-text px-5" v-if="!this.brandConfig.isBeatTheJams">Please choose a
      subscription package</h5>
    <div class="manage-subscription-info col-9 mt-3">Choose a subscription
      package to join Melody Madness
    </div>
    <div @click="onPackageClicked()"
         class="d-flex flex-column justify-content-center manage-subscription-container-mtn primary-text  mt-2 col-8"
         v-bind:class="getPricePointClass(2)">
      R3/Day
    </div>
    <div @click="onPackageClicked()"
         class="d-flex flex-column justify-content-center manage-subscription-container-mtn primary-text  mt-2 col-8"
         v-bind:class="getPricePointClass(3)">
      R10/week
    </div>
    <div @click="onPackageClicked()"
         class="d-flex flex-column justify-content-center manage-subscription-container-mtn primary-text  mt-2 col-8"
         v-bind:class="getPricePointClass(4)">
      R30/Month
    </div>
    <h5 class="text-center mt-3 primary-text" @click="onCancelClicked()"><u>CANCEL</u></h5>
  </div>

  <FooterNav/>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import DcbService from "@/services/dcbService";
import setUserSessionData from "@/functions/setUserSessionData";
import {getNetwork, serviceIdMap} from "@/config";
import FooterNav from "@/views/components/FooterNav";
import PlayerServiceBoxOne from "@/views/components/PlayerServiceBoxOne";
import PlayerServiceBoxTwo from "@/views/components/PlayerServiceBoxTwo";
import DepService from "@/services/depService";
import {environmentConfig} from "@/config/enviromentConfig";
import PlayerServiceBoxThree from "@/views/components/PlayerServiceBoxThree";

export default {
  name: "ManageSubscription",
  components: {
    FooterNav,
    PlayerServiceBoxOne,
    PlayerServiceBoxTwo,
    PlayerServiceBoxThree
  },
  data() {
    return {
      userAvatar: undefined,
      unsubscribeContainer: false,
      buttonBorder: '.2px solid #C10041',
      showMtnPackages: false,
      userPricePoint: undefined,
      selectedPackage: undefined,
      selectedServiceId: undefined,
      subscriptionId: undefined
    }
  },
  computed: {
    ...mapState(['brandConfig', 'user', 'productId']),
  },
  methods: {
    ...mapMutations(['setSubscriptionType', 'setUser', 'setGameState', 'setCategoryGameState', 'setIsLoading']),
    async onConfirmPackageClicked() {
      this.setIsLoading(true)
      const response = await DepService.subscribeUser(this.user.Msisdn, this.selectedServiceId, this.subscriptionId, this.productId, 0, null);
      this.setIsLoading(false)
      if (!response.data.result) return this.$router.push(`/error/${response.data.reason}`)
      if (response.data.result) {
        this.setUser(response.data.user)
        this.$router.push(`/profile`)
      }
    },
    async updateUser() {
      const user = getNetwork(this.brandConfig.brand) ? (await DcbService.getUserViaProductId(this.user.Msisdn, this.productId)).data : (await TelkomService.getUser(this.user.Msisdn, this.productId)).data.user;
      this.setUser(user)
    },
    goBackClicked() {
      this.$router.go(-1)
    },
    getCorrectServiceId(pricePoint) {
      if (pricePoint === 'R5/Day' && environmentConfig.nodeEnv === 'Prod') return 10588
      if (pricePoint === 'R35/Week' && environmentConfig.nodeEnv === 'Prod') return 10589
      if (pricePoint === 'R45/Month' && environmentConfig.nodeEnv === 'Prod') return 10590
      if (pricePoint === 'R5/Day' && environmentConfig.nodeEnv === 'Staging') return 45747
      if (pricePoint === 'R35/Week' && environmentConfig.nodeEnv === 'Staging') return 45748
      if (pricePoint === 'R45/Month' && environmentConfig.nodeEnv === 'Staging') return 45749
    },
    async onPackageClicked() {
      window.open(`https://google.com`, '_self')
    },
    onCancelClicked() {
      this.$router.go(-1)
    },
    chagePaymentPlanClicked() {
      this.showMtnPackages = true
    },

    getPricePointClass(pricePointId) {
      if (this.getServiceIdMapNumber(this.user.Service) === 1) return 'yellow-border'
      if (this.getServiceIdMapNumber(this.user.Service) === pricePointId) return 'yellow-bg'
      else return 'yellow-border'

    },
    setButtonBorder() {
      if (this.getServiceIdMapNumber(this.user.Service) === 1 && getNetwork(this.brandConfig.brand)) this.buttonBorder = '.2px solid #C10041'
      if (this.getServiceIdMapNumber(this.user.Service) === 1 && !getNetwork(this.brandConfig.brand)) this.buttonBorder = '.2px solid #7C0096'
      if (this.getServiceIdMapNumber(this.user.Service) === 2 && getNetwork(this.brandConfig.brand)) this.buttonBorder = '.2px solid #007FB7'
      if (this.getServiceIdMapNumber(this.user.Service) === 3 && getNetwork(this.brandConfig.brand)) this.buttonBorder = '.2px solid #E60000'
      if (this.getServiceIdMapNumber(this.user.Service) > 1 && !getNetwork(this.brandConfig.brand)) this.buttonBorder = '.2px solid #FFCB05'
      if (this.getServiceIdMapNumber(this.user.Service) === 3) this.buttonBorder = '.2px solid #E60000'
    },

    getServiceIdMapNumber(service) {
      return serviceIdMap.get(service)
    },

    getColoursByServiceId(serviceId, type) {
      if (this.getServiceIdMapNumber(serviceId) === 1) return `primary-free-${type}-colour`
      if (this.getServiceIdMapNumber(serviceId) === 2) return `primary-vip-${type}-colour`
      if (this.getServiceIdMapNumber(serviceId) === 3) return `primary-vvip-${type}-colour`
    },
    routeToPage(pageRoute) {
      this.$router.push(`/${pageRoute}`)
    },
    getUserAvatar() {
      this.userAvatar = this.user.Avatar
    },
    async subscribeClicked(pageRoute, subscriptionType) {
      const service = subscriptionType === "vip" ? "vc-fanclash-beatthejams-01" : "vc-fanclash-beatthejams-02";
      await DcbService.doiOne(this.user.Msisdn, service);
      this.setSubscriptionType(subscriptionType)
      this.routeToPage(pageRoute)
    },
    unsubscribeClicked() {
      this.unsubscribeContainer = !this.unsubscribeContainer
    },
    async confirmUnsubscribeClicked() {
      this.setIsLoading(true);
      await this.updateUser();
      const sessionId = localStorage.getItem("sessionId");
      if (getNetwork(this.brandConfig.brand)) await DcbService.doiCancel(this.user.Msisdn, this.user.Service);
      if (getNetwork(this.brandConfig.brand)) await DcbService.unSubscribeUser(this.user.Msisdn, this.user.Service, false, sessionId);
      if (!getNetwork(this.brandConfig.brand)) await DepService.unSubscribeUser(this.user.subscriptionId);
      const freePlayService = this.brandConfig.freePlayServiceId;
      const user = getNetwork(this.brandConfig.brand) ? (await DcbService.getUserViaProductId(this.user.Msisdn, this.productId)).data : (await TelkomService.getUser(this.user.Msisdn, this.productId)).data.user;
      setUserSessionData(this.user.Msisdn, freePlayService);
      this.setUser(user);
      this.setIsLoading(false);
      this.$router.push('/login');
    },
  },
  beforeMount() {
    this.getUserAvatar();
    this.setButtonBorder();
    if (this.brandConfig.brand === 'mtn-za-en') this.showMtnPackages = true
  }
}
</script>

<style scoped>
.height {
  height: 80svh !important;
}
.game-logo-icon-lrg {
  width: 200px;
  height: auto;
}

.background-icon {
  width: 230px;
}

.back-icon, .hamburger-icon {
  position: absolute;
  top: 70px
}

.hamburger-icon {
  right: 20px;
}

.back-icon {
  left: 20px;
}

.hamburger-icon, .back-icon {
  height: 25px;
}

.game-logo {
  z-index: 1;
  position: relative;
}

.user-avatar {
  position: relative;
  bottom: 0px;
  z-index: 0;
}

.header-text {
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.09px;
}

.manage-subscription-info {
  color: #FFF;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
}

.yellow-bg {
  background: #BAF600;
}

.black-bg {
  background: #000;
}

.yellow-border {
  border: 1px solid #BAF600;
}

.manage-subscription-container-mtn {
  border-radius: 29px;
  font-size: 14px;
  font-weight: 700;
  height: 45px;
}

.manage-subscription-container, .unsubscribe-container {
  border-radius: 14px;
  font-size: 14px;
  font-weight: 700;
  height: 45px;
}

.unsubscribe-container {
  border: v-bind('buttonBorder')
}

.vip-container {
  position: absolute;
  top: 20px;
  right: 10px;
}

.vip-logo {
  width: 100px;
}

.price-point-text {
  margin-left: 2px;
  font-family: 'Poppins Regular', sans-serif;
}

</style>
